module.exports = __webpack_public_path__ + "media/sos_tutorial.d9dd7269.mp4";